/**
 * Annotation shape utilities - extracted to break circular dependency
 * between docShapes.ts and docGetShape.ts
 */
import type { Annotation } from "building-types/annotation/annotationTypes";
import { AnnotationType } from "building-types/annotation/annotationTypesEnum";
import type { Asset } from "building-types/entities/asset";
import type { Table } from "common/data/table";
import type { PolyLine2 } from "geom/polyLine2Types";
import { polyLine2New } from "geom/polyLine2Types";
import { detailOutlineBoxToPolyLine2 } from "./utils/annotation";

export function annotationShapeToPolyLine2(annot: Annotation, assetCatalog: Table<Asset>): PolyLine2 | undefined {
  switch (annot?.type) {
    case AnnotationType.LINEWORK: {
      return annot.path;
    }
    case AnnotationType.DETAIL: {
      return detailOutlineBoxToPolyLine2(annot, assetCatalog);
    }
    case AnnotationType.NOTE: {
      const pts = [annot.x, annot.y];
      if (typeof annot.landingLineX === "number" && typeof annot.landingLineY === "number") {
        pts.push(annot.landingLineX, annot.landingLineY);
      }
      if (typeof annot.leaderLineX === "number" && typeof annot.leaderLineY === "number") {
        pts.push(annot.leaderLineX, annot.leaderLineY);
      }
      return polyLine2New(pts);
    }
    default:
      return undefined;
  }
}
